import { Button, Dropdown, Menu } from 'antd';
import styled from 'styled-components';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface IExpandIcon {
  theme: ITheme;
  isOpened?: boolean;
}

export const ExpandIcon = styled.div<IExpandIcon>`
  ${({ isOpened }: IExpandIcon) => `
       transition: linear 0.2s;
       transition-timing-function: cubic-bezier(.47,.13,.23,.92);
       transform: ${isOpened ? 'translateY(-4px) rotate(180deg)' : 'translateY(2px) rotate(0deg)'};
  `}
`;

export const SelectCont = styled(Dropdown)`
  align-items: center;
  display: flex;
  height: 100%;
`;

export const SelectedItemCont = styled.span`
  min-width: 23px;
`;

export const ButtonCont = styled(Button)`
  display: flex;
  padding: 4px 12px;
  ${({ theme }: IThemeProvider) => `
    border: 1px solid ${theme.colors.neutral.primary[10]};
    border-radius: ${theme.layout.spacing.mikro};
    color: ${theme.colors.neutral.primary[100]};
  `}

  span {
    font-size: 14px;
    line-height: 17px;
  }

  &:hover,
  &:focus {
    ${({ theme }: IThemeProvider) => `
    border: 1px solid ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro};
    color: ${theme.colors.neutral.primary[100]};
  `}
  }

  &.ant-dropdown-open {
    ${({ theme }: IThemeProvider) => `
    border-radius: 0 0 ${theme.layout.spacing.mikro} ${theme.layout.spacing.mikro};
  `}
  }
`;

export const MenuCont = styled(Menu)`
  ${({ theme }: IThemeProvider) => `
    border: 1px solid ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro} ${theme.layout.spacing.mikro} 0 0;
    color: ${theme.colors.neutral.primary[100]};
    padding: 0;
  `}

  .ant-dropdown-menu-item {
    &:first-child {
      ${({ theme }: IThemeProvider) => `
        border-radius: ${theme.layout.spacing.mikro} ${theme.layout.spacing.mikro} 0 0;
      `}
    }

    &:hover {
      ${({ theme }: IThemeProvider) => `
        background: ${theme.colors.neutral.primary[10]};
        color: ${theme.colors.neutral.primary[100]};
      `}
    }
  }

  .ant-dropdown-menu-item-selected {
    ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.primary[10]};
      color: ${theme.colors.primary[100]};
    `}
  }
`;
